import { render, staticRenderFns } from "./UsedCarValuation.vue?vue&type=template&id=3b85331c"
import script from "./UsedCarValuation.vue?vue&type=script&lang=js"
export * from "./UsedCarValuation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports